import React from 'react';

export default function SVGScrollArrow(): JSX.Element {
  return (
    <svg
      width="54"
      height="55"
      viewBox="0 0 54 55"
      fill="none"
      className="text-iconStrong fill-current"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b)">
        <circle cx="27" cy="27.5" r="27" />
      </g>
      <path d="M16.5 24L26.5 34.5L36.5 24" stroke="white" strokeWidth="4" strokeLinecap="round" />
      <defs>
        <filter
          id="filter0_b"
          x="-4"
          y="-3.5"
          width="62"
          height="62"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImage" stdDeviation="2" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}
